/**
 * Method: GET
 */
import { TypeInt } from "./common/TypeInt";
import { OutputBase } from "./common/OutputBase";
import { InputBase } from "./common/InputBase";

class PanelGetInput extends InputBase {
	id: number;
}

export class PanelGetOutput extends OutputBase {
	ok: {
		data: PanelGetData
	}
	error: {
	}
}

export class PanelGetData {
	id: number;
	name: string;
	senItemID: string;
	shortName: string;
	imageURL: string;
	manufacturer: string;
	Icoeff: number;
	Vcoeff: number;
	Ipm: number;
	Vpm: number;
	Voc: number;
	Vsys: number;
	Pdc: number;
	Isc: number;
	Ireverse: number;
	type: number;
	width: number;
	height: number;
	thickness: number;
	landscape: boolean;
	stock: {
		text: string,
		iconURL: string,
	}
}